import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';

/** Material datepicker / input display: MM / DD / YYYY (spaces around slashes). */
export const YMD_SPACED_DATE_FORMATS = {
  parse: { dateInput: 'MM/dd/yyyy' },
  display: {
    dateInput: 'MM/dd/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'MM/dd/yyyy',
    monthYearA11yLabel: 'MMMM yyyy'
  }
};

export class YmdSpacedNativeDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: any): string {
    if (!date) return '';
    var y = date.getFullYear();
    var mo = ('0' + (date.getMonth() + 1)).slice(-2);
    var da = ('0' + date.getDate()).slice(-2);
    return mo + ' / ' + da + ' / ' + y;
  }

  parse(value: any): Date | null {
    if (typeof value === 'string' && value.length) {
      var parts = value.split('/').map(function (p) { return (p || '').trim(); });
      if (parts.length === 3) {
        var monthNum = Number(parts[0]);
        var dayNum = Number(parts[1]);
        var yearNum = Number(parts[2]);
        if (!isNaN(yearNum) && !isNaN(monthNum) && !isNaN(dayNum)) {
          return new Date(yearNum, monthNum - 1, dayNum);
        }
      }
    }
    return super.parse(value);
  }
}
